"use client";
import { useEffect, useState } from "react";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { LayoutProps } from "@/components/layout/layoutType";
import { Debug } from "@/util/debug";
import Link from "next/link";
import Icon from "@/components/common/icon/sicon";
import { getPrefetch } from "@/util/apputil";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/sicon"), { ssr: false });

export default function NotAuth({ params }: { params?: LayoutProps }) {
  const t = useTranslations("alert");
  const [loading, setLoading] = useState<boolean>(true);
  const prefetch = getPrefetch();

  useEffect(() => {
    setLoading(false);
  }, []);
  let auth_text: string | undefined = undefined;
  let link_text: string | undefined = undefined;
  let icon_name = "GlobeSimpleX";
  let create_link = "/create";
  if (params?.page.auth) {
    for (const temp_auth in params.page.auth) {
      switch (temp_auth) {
        case "roaster":
          auth_text = "noroaster_text";
          link_text = "noroaster_link";
          icon_name = "Factory";
          create_link = "/roaster/create";
          break;
        case "cafe":
          auth_text = "nocafe_text";
          link_text = "nocafe_link";
          icon_name = "Coffee";
          create_link = "/cafe/create";
          break;
      }
      if (auth_text != undefined) {
        break;
      }
    }
  }

  return (
    <Container size="1" className=" mt-16 lg:mt-32 text-center group">
      <Skeleton loading={loading}>
        <Icon
          iconType="phosphor"
          iconName={icon_name}
          className={"size-64 inline-block animate-infinite group-hover:animate-wiggle"}
          weight="thin"
          size={64}
        />
      </Skeleton>

      <Skeleton loading={loading}>
        <Text as="div" size="4" weight="bold" className="flex min-w-12 justify-center mt-12">
          {auth_text ? t(auth_text) : ""}
        </Text>
      </Skeleton>
      <Skeleton loading={loading}>
        <Text as="div" size="4" weight="bold" className="flex min-w-12 justify-center mt-1">
          {link_text
            ? t.rich(link_text, {
                create: (chunks) => (
                  <Link href={create_link} prefetch={prefetch} className="ml-2 link-font-accent">
                    {chunks}
                  </Link>
                ),
              })
            : ""}
        </Text>
      </Skeleton>
    </Container>
  );
}
